/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Passkey_Secret_ExpiredInputs */

const es_co2_error_passkey_secret_expired = /** @type {(inputs: Error_Passkey_Secret_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta llave expiró.`)
};

/**

* @param {Error_Passkey_Secret_ExpiredInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_passkey_secret_expired = /** @type {((inputs?: Error_Passkey_Secret_ExpiredInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Passkey_Secret_ExpiredInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_passkey_secret_expired(inputs)
});